module.exports = __webpack_public_path__ + "static/media/cancleButton.0024b429.svg";